import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getConfigurations,
  getCategories,
  bulkAddConfigurations,
  deleteConfiguration,
  bulkDeleteConfigurations,
} from '../../actions/aiAssistConfigActions';
import Loading from '../common/Loading';
import './savedConfigurationModal.scss';
import Select, { components } from 'react-select';

const DropdownIndicator = (props) =>
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <i className="material-icons custom">arrow_drop_down</i>
    </components.DropdownIndicator>
  );

const multiSelectdropdownCustomStyle = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#007bff' : 'white',
    padding: '10px',
    color: '#000',
    ':hover': {
      backgroundColor: '#f0f0f0',
    },
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 90,
    overflowY: 'auto',
  }),
  control: (base) => ({
    ...base,
    border: '1px solid #CFD0D1',
    padding: '6px',
    boxShadow: 'none',
    outline: 'none',
    '&:hover': {
      border: '1px solid #CFD0D1',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px',
  }),
};

class SavedConfigurationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filteredData: [],
      showCsvUploadModal: false,
      uploadError: null,
      isProcessing: false,
      csvData: [],
      isSavingCsv: false,
      saveError: null,
      validationErrors: [],
      uploadProgress: 0,
      csvPreviewColumns: [],
      showCsvPreview: false,
      localSearchTerm: props.searchTerm || '',
      editingConfigId: null,
      editFormData: {},
      isUpdating: false,
      updateError: null,
      categoriesLoaded: false,
      loadingCategories: false,
      isDeletingConfig: false,
      showConfirmModal: false,
      confirmModalConfig: {
        title: '',
        message: '',
        onConfirm: null,
        onCancel: null,
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        type: 'confirm',
      },
      showSuccessModal: false,
      successMessage: '',
      showErrorModal: false,
      errorMessage: '',
      selectedConfigs: [],
      isSelectMode: false,
      isBulkDeleting: false,
    };

    this.fileInputRef = React.createRef();
  }

  validateField = (fieldValue, fieldName) => {
    const errors = [];

    if (typeof fieldValue === 'undefined') {
      errors.push(`${fieldName} cannot be undefined.`);
      return errors;
    }

    if (fieldValue === null) {
      errors.push(`${fieldName} cannot be null.`);
      return errors;
    }

    if (typeof fieldValue !== 'string') {
      errors.push(`${fieldName} must be a string, not ${typeof fieldValue}.`);
      return errors;
    }

    if (fieldValue === '') {
      errors.push(`${fieldName} cannot be an empty string.`);
      return errors;
    }

    if (fieldValue.trim() === '') {
      errors.push(`${fieldName} cannot contain only whitespace.`);
      return errors;
    }

    const emojiRegex = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1F004}]|[\u{1F0CF}]|[\u{1F170}-\u{1F251}]/gu;

    if (emojiRegex.test(fieldValue)) {
      errors.push(`${fieldName} cannot contain emojis.`);
    }

    const onlySpecialCharsRegex = /^[^a-zA-Z0-9\s]+$/;
    if (onlySpecialCharsRegex.test(fieldValue.trim())) {
      errors.push(`${fieldName} cannot contain only special characters.`);
    }

    const onlyNumbersRegex = /^\d+$/;
    if (onlyNumbersRegex.test(fieldValue.trim())) {
      errors.push(`${fieldName} cannot contain only numbers.`);
    }

    const noLettersRegex = /^[^a-zA-Z]+$/;
    if (noLettersRegex.test(fieldValue.trim())) {
      errors.push(`${fieldName} must contain at least one letter.`);
    }

    return errors;
  };

  validateExpiryDate = (dateValue) => {
    const errors = [];

    if (!dateValue || dateValue.trim() === '') {
      errors.push('Expiry date is required');
      return errors;
    }

    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateValue)) {
      errors.push('Expiry date must be in YYYY-MM-DD format');
      return errors;
    }

    const expiryDate = new Date(dateValue);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (isNaN(expiryDate.getTime())) {
      errors.push('Invalid expiry date');
      return errors;
    }

    if (expiryDate <= today) {
      errors.push('Expiry date must be a future date');
      return errors;
    }

    return errors;
  };

  getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
  };

  showConfirmDialog = (
    title,
    message,
    onConfirm,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
  ) => {
    this.setState({
      showConfirmModal: true,
      confirmModalConfig: {
        title,
        message,
        onConfirm,
        onCancel: () => this.setState({ showConfirmModal: false }),
        confirmText,
        cancelText,
        type: 'confirm',
      },
    });
  };

  showSuccessDialog = (message) => {
    this.setState({
      showSuccessModal: true,
      successMessage: message,
    });
  };

  showErrorDialog = (message) => {
    this.setState({
      showErrorModal: true,
      errorMessage: message,
    });
  };

  closeAllModals = () => {
    this.setState({
      showConfirmModal: false,
      showSuccessModal: false,
      showErrorModal: false,
      confirmModalConfig: {
        title: '',
        message: '',
        onConfirm: null,
        onCancel: null,
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        type: 'confirm',
      },
      successMessage: '',
      errorMessage: '',
    });
  };

  getDefaultCategories = () => {
    return [
      "Appointment",
      "Class",
      "Financing",
      "General FAQ",
      "Giftcard, Groupon, Vouchers",
      "AcceptedInsurance",
      "UnAcceptedInsurance",
      "Insurance",
      "Memberships",
      "Offers \u0026 Promotions",
      "Payment, Billing",
      "Pricing",
      "Reports",
      "Service",
      "Staff",
      "GeneralInformation",
      "PharmacyRecords",
      "Payment, Billing",
      "GeneralFAQ",
      "InsuranceAIAssists"
    ];
  };

  getAvailableCategories = () => {
    if (
      this.props.availableCategories &&
      this.props.availableCategories.length > 0
    ) {
      return this.props.availableCategories;
    }
    return this.getDefaultCategories();
  };

  async componentDidMount() {
    if (this.props.configurations && this.props.configurations.length > 0) {
      this.updateFilteredData();
    }
    try {
      const result = await this.props.getConfigurations();
      setTimeout(() => {
        this.updateFilteredData();
      }, 500);
    } catch (error) {
      console.error('Error loading configurations:', error);
    }
    await this.loadCategories();
  }

  loadCategories = async () => {
    this.setState({ loadingCategories: true });

    try {
      const categories = await this.props.getCategories();
      setTimeout(() => {
        this.setState({
          categoriesLoaded: true,
          loadingCategories: false,
        });
      }, 100);
    } catch (error) {
      this.setState({
        categoriesLoaded: true,
        loadingCategories: false,
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.configurations !== this.props.configurations) {
      this.updateFilteredData();
    }

    if (prevProps.loading && !this.props.loading) {
      this.updateFilteredData();
    }

    if (prevProps.availableCategories !== this.props.availableCategories) {
      if (
        this.props.availableCategories &&
        this.props.availableCategories.length > 0
      ) {
        this.setState({ categoriesLoaded: true });
      }
    }

    if (prevState.localSearchTerm !== this.state.localSearchTerm) {
      this.filterData(this.state.localSearchTerm);
    }

    if (prevState.csvData !== this.state.csvData) {
      this.updateFilteredData();
    }

    if (
      prevState.filteredData !== this.state.filteredData &&
      this.state.isSelectMode
    ) {
      const validSelectedConfigs = this.state.selectedConfigs.filter((id) =>
        this.state.filteredData.some((config) => config.id === id),
      );

      if (validSelectedConfigs.length !== this.state.selectedConfigs.length) {
        this.setState({ selectedConfigs: validSelectedConfigs });
      }
    }
  }

  updateFilteredData = () => {
    const reduxConfigurations = Array.isArray(this.props.configurations)
      ? this.props.configurations
      : [];

    const combinedData = [...reduxConfigurations, ...this.state.csvData];

    const formattedData = combinedData.map((config, index) => {
      const formattedConfig = {
        id:
          config.id ||
          config.new_solr_id ||
          config.document_id ||
          `temp_${Date.now()}_${index}_${Math.random()}`,
        UserMessage:
          config.UserMessage ||
          config.user_message ||
          config.Context ||
          config.context ||
          '',
        Response: config.Response || config.response || '',
        ExpiryDate: this.formatDate(
          config.ExpiryDate || config.expiry_date || config.expiryDate,
        ),
        Categories: this.formatCategories(
          config.Categories || config.category || config.categories,
        ),
        updatedBy: config.updatedBy || null,
        updatedOn: this.formatDate(config.updatedOn),
        isFromCsv: config.isFromCsv || false,
      };

      return formattedConfig;
    });

    const sortedData = formattedData.sort((a, b) => {
      const dateA = a.updatedOn ? new Date(a.updatedOn) : new Date(0);
      const dateB = b.updatedOn ? new Date(b.updatedOn) : new Date(0);
      return dateB.getTime() - dateA.getTime();
    });
  
    this.setState({
      filteredData: sortedData,
    });
  };

  formatDate = (date) => {
    if (
      !date ||
      date === '' ||
      date === null ||
      date === undefined ||
      date === 'null'
    ) {
      return null;
    }

    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }

    try {
      const parsedDate = new Date(date);
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate.toISOString().split('T')[0];
      }
    } catch (e) {
      console.warn('Could not parse date:', date);
    }

    return date.toString().trim() || null;
  };

  formatCategories = (categories) => {
    if (!categories) {
      return [];
    }

    if (Array.isArray(categories)) {
      return categories.filter(
        (cat) => cat && typeof cat === 'string' && cat.trim(),
      );
    }

    if (typeof categories === 'string') {
      if (categories.trim() === '') {
        return [];
      }
      return categories
        .split(/[;,|]/)
        .map((cat) => cat.trim())
        .filter((cat) => cat);
    }
    return [];
  };

  filterData = (searchTerm) => {
    if (!searchTerm || searchTerm.trim() === '') {
      this.updateFilteredData();
      return;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    const reduxConfigurations = Array.isArray(this.props.configurations)
      ? this.props.configurations
      : [];

    const combinedData = [...reduxConfigurations, ...this.state.csvData];

    const filtered = combinedData.filter((config) => {
      const userMessage = (
        config.UserMessage ||
        config.user_message ||
        config.Context ||
        config.context ||
        ''
      ).toLowerCase();
      const response = (config.Response || config.response || '').toLowerCase();
      const categories = this.formatCategories(
        config.Categories || config.category || config.categories,
      );

      const categoryMatch = categories.some(
        (cat) => cat && cat.toLowerCase().includes(lowerSearchTerm),
      );

      return (
        userMessage.includes(lowerSearchTerm) ||
        response.includes(lowerSearchTerm) ||
        categoryMatch
      );
    });

    const formattedFiltered = filtered.map((config, index) => ({
      id:
        config.id ||
        config.new_solr_id ||
        config.document_id ||
        `temp_${Date.now()}_${index}_${Math.random()}`,
      UserMessage:
        config.UserMessage ||
        config.user_message ||
        config.Context ||
        config.context ||
        '',
      Response: config.Response || config.response || '',
      ExpiryDate: this.formatDate(
        config.ExpiryDate || config.expiry_date || config.expiryDate,
      ),
      Categories: this.formatCategories(
        config.Categories || config.category || config.categories,
      ),
      updatedBy: config.updatedBy || null,
      updatedOn: this.formatDate(config.updatedOn),
      isFromCsv: config.isFromCsv || false,
    }));

    const sortedData = formattedFiltered.sort((a, b) => {
      const dateA = a.updatedOn ? new Date(a.updatedOn) : new Date(0);
      const dateB = b.updatedOn ? new Date(b.updatedOn) : new Date(0);
      return dateB.getTime() - dateA.getTime();
    });
  
    this.setState({ filteredData: sortedData });
  };

  handleEdit = async (config) => {
    if (config.isFromCsv) {
      this.showErrorDialog('Please save the CSV data first before editing.');
      return;
    }
    if (
      !this.props.availableCategories ||
      this.props.availableCategories.length === 0
    ) {
      try {
        await this.loadCategories();
      } catch (error) {
        console.error('Failed to refresh categories for edit:', error);
      }
    }

    const getUserMessage = (config) => {
      return (
        config.UserMessage ||
        config.user_message ||
        config.Context ||
        config.context ||
        config.UserQuestion ||
        config.question ||
        ''
      );
    };

    const getResponse = (config) => {
      return (
        config.Response ||
        config.response ||
        config.Answer ||
        config.answer ||
        ''
      );
    };

    const getExpiryDate = (config) => {
      const date =
        config.ExpiryDate ||
        config.expiry_date ||
        config.expiryDate ||
        config.expiry ||
        '';

      if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return date;
      }
      try {
        const parsedDate = new Date(date);
        if (!isNaN(parsedDate.getTime())) {
          const formattedDate = parsedDate.toISOString().split('T')[0];
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (parsedDate <= today) {
            return this.getTomorrowDate();
          }
          return formattedDate;
        }
      } catch (e) {
        console.warn('Could not parse date:', date);
      }

      return ''; 
    };

    const getCategories = (config) => {
      const categories =
        config.Categories ||
        config.category ||
        config.categories ||
        config.Category ||
        [];

      if (Array.isArray(categories)) {
        return categories.filter((cat) => cat && cat.trim());
      }
      if (typeof categories === 'string' && categories.trim()) {
        return categories
          .split(/[;,|]/)
          .map((cat) => cat.trim())
          .filter((cat) => cat);
      }
      return [];
    };

    const editFormData = {
      UserMessage: getUserMessage(config),
      Response: getResponse(config),
      ExpiryDate: getExpiryDate(config),
      Categories: getCategories(config),
      id: config.id || config.document_id || config.new_solr_id,
    };

    this.setState({
      editingConfigId: config.id || config.document_id || config.new_solr_id,
      editFormData: editFormData,
      updateError: null,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editingConfigId: null,
      editFormData: {},
      updateError: null,
      isUpdating: false,
    });
  };

  handleEditFormChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value,
      },
    });
  };

  handleCategoryChange = (categories) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        Categories: categories,
      },
    });
  };

  handleSaveEdit = async () => {
    const { editFormData } = this.state;

    const validationErrors = [];

    const userMessageErrors = this.validateField(
      editFormData.UserMessage,
      'User Message',
    );
    validationErrors.push(...userMessageErrors);

    const responseErrors = this.validateField(
      editFormData.Response,
      'Response',
    );
    validationErrors.push(...responseErrors);

    // const expiryDateErrors = this.validateExpiryDate(editFormData.ExpiryDate);
    // validationErrors.push(...expiryDateErrors);

    if (!editFormData.Categories || editFormData.Categories.length === 0) {
      validationErrors.push('At least one category is required');
    }

    if (validationErrors.length > 0) {
      this.setState({ updateError: validationErrors.join(', ') });
      return;
    }

    this.setState({ isUpdating: true, updateError: null });

    try {
      if (typeof this.props.onUpdate !== 'function') {
        throw new Error('Update function not available');
      }

      const updateData = {
        id: editFormData.id,
        context: editFormData.UserMessage.trim(),
        response: editFormData.Response.trim(),
        expiryDate: editFormData.ExpiryDate === '' ? null : editFormData.ExpiryDate,
        category: editFormData.Categories || [],
        documentId: editFormData.id,
      };

      await this.props.onUpdate(updateData);

      if (typeof this.props.getConfigurations === 'function') {
        await this.props.getConfigurations();

        setTimeout(() => {
          this.updateFilteredData();
        }, 100);
      }

      this.handleCancelEdit();

      this.showSuccessDialog('Configuration updated successfully!');
    } catch (error) {
      console.error('Update error:', error);
      this.setState({
        updateError: error.message || 'Failed to update configuration',
        isUpdating: false,
      });
    }
  };

  handleDelete = async (id) => {
    const csvItem = this.state.csvData.find((item) => item.id === id);
    if (csvItem) {
      this.showConfirmDialog(
        'Remove CSV Item',
        'Are you sure you want to remove this item from the upload list?',
        () => {
          const updatedCsvData = this.state.csvData.filter(
            (item) => item.id !== id,
          );
          this.setState({ csvData: updatedCsvData });
          this.closeAllModals();
        },
        'Remove',
        'Cancel',
      );
      return;
    }

    const configToDelete = this.state.filteredData.find(
      (config) => config.id === id,
    );

    if (!configToDelete) {
      this.showErrorDialog('Configuration not found');
      return;
    }

    this.showConfirmDialog(
      'Delete Configuration',
      'Are you sure you want to delete this configuration? This action cannot be undone.',
      async () => {
        try {
          this.setState({
            showConfirmModal: false,
            isDeletingConfig: true,
            localSearchTerm: '',
          });

          await this.props.deleteConfiguration(configToDelete);

          await this.props.getConfigurations();

          this.setState({ isDeletingConfig: false });
          this.updateFilteredData();

          this.showSuccessDialog('Configuration deleted successfully!');
        } catch (error) {
          this.setState({ isDeletingConfig: false });
          this.showErrorDialog(
            `Failed to delete configuration: ${error.message ||
              'Unknown error'}`,
          );
        }
      },
      'Delete',
      'Cancel',
    );
  };

  downloadCsv = () => {
    const data = Array.isArray(this.props.configurations)
      ? this.props.configurations
      : [];

    if (data.length === 0) {
      this.showErrorDialog('No configurations to download');
      return;
    }

    try {
      const csvHeaders = [
        'Config id',
        'Context',
        'Response',
        'Expiry date',
        'Category',
      ];

      const csvData = data.map((config) => {
        const categories = this.formatCategories(
          config.Categories || config.category || config.categories,
        );
        const categoriesString = categories.join(';');

        const configId = config.id || config.documentId || '';

        return [
          `"${configId}"`,
          `"${(
            config.UserMessage ||
            config.user_message ||
            config.context ||
            ''
          ).replace(/"/g, '""')}"`,
          `"${(config.Response || config.response || '').replace(/"/g, '""')}"`,
          config.ExpiryDate || config.expiry_date || '',
          `"${categoriesString}"`,
        ];
      });

      const csvContent = [
        csvHeaders.join(','),
        ...csvData.map((row) => row.join(',')),
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute(
        'download',
        `ai-assists-${new Date().toISOString().split('T')[0]}.csv`,
      );
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      this.showErrorDialog('Failed to download CSV file. Please try again.');
    }
  };

  handleCsvUpload = () => {
    this.setState({
      showCsvUploadModal: true,
      uploadError: null,
      saveError: null,
      validationErrors: [],
      showCsvPreview: false,
      csvPreviewColumns: [],
      csvData: [],
    });
  };

  closeCsvUploadModal = () => {
    this.setState({
      showCsvUploadModal: false,
      uploadError: null,
      saveError: null,
      isProcessing: false,
      isSavingCsv: false,
      validationErrors: [],
      uploadProgress: 0,
      showCsvPreview: false,
      csvPreviewColumns: [],
      csvData: [],
    });
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  };

  handleFileSelect = async (event) => {
    const file = event.target.files[0];

    if (!file.name.toLowerCase().endsWith('.csv')) {
      this.setState({ uploadError: 'Please select a CSV file' });
      return;
    }

    this.setState({
      isProcessing: true,
      uploadError: null,
      saveError: null,
      validationErrors: [],
      uploadProgress: 20,
    });

    try {
      this.setState({ uploadProgress: 40 });
      const fileContent = await this.readFileContent(file);

      this.setState({ uploadProgress: 60 });
      const parsedData = this.parseCSV(fileContent);

      this.setState({ uploadProgress: 80 });
      const {
        configurations,
        errors,
        previewColumns,
      } = this.convertCsvToConfigurations(parsedData);

      this.setState({
        csvData: configurations,
        validationErrors: errors,
        csvPreviewColumns: previewColumns,
        showCsvPreview: true,
        isProcessing: false,
        uploadProgress: 100,
      });
    } catch (error) {
      console.error('File processing error:', error);
      this.setState({
        uploadError: error.message || 'Failed to process CSV file',
        isProcessing: false,
        uploadProgress: 0,
      });
    }
  };

  readFileContent = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (e) => reject(new Error('Failed to read file'));
      reader.readAsText(file);
    });
  };

  parseCSV = (csvContent) => {
    const lines = csvContent.split('\n').filter((line) => line.trim());
    if (lines.length < 2) {
      throw new Error('CSV file must have at least a header and one data row');
    }

    const headers = this.parseCSVLine(lines[0]);
    const rows = lines.slice(1).map((line) => this.parseCSVLine(line));

    return rows.map((row, index) => {
      const obj = {};
      headers.forEach((header, headerIndex) => {
        const cleanHeader = header.trim();
        let value = row[headerIndex] || '';

        if (value.startsWith('"') && value.endsWith('"')) {
          value = value.slice(1, -1).replace(/""/g, '"');
        }

        obj[cleanHeader] = value;
      });
      obj._rowNumber = index + 2;
      return obj;
    });
  };

  parseCSVLine = (line) => {
    const result = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      const nextChar = line[i + 1];

      if (char === '"') {
        if (inQuotes && nextChar === '"') {
          current += '"';
          i++;
        } else {
          inQuotes = !inQuotes;
        }
      } else if (char === ',' && !inQuotes) {
        result.push(current);
        current = '';
      } else {
        current += char;
      }
    }

    result.push(current);
    return result;
  };

  convertCsvToConfigurations = (parsedData) => {
    const configurations = [];
    const errors = [];
    const previewColumns = [];
    const errorsByCategory = {
      'Missing Context': [],
      'Invalid Context': [],
      'Missing Response': [],
      'Invalid Response': [],
      'Missing Expiry Date': [],
      'Invalid Expiry Date': [],
      'Past Expiry Date': [],
      'Missing Category': [],
      'Invalid Category': [],
    };

    if (parsedData.length > 0) {
      const sampleRow = parsedData[0];
      previewColumns.push(
        ...Object.keys(sampleRow).filter((key) => !key.startsWith('_')),
      );
    }

    const validCategories = this.getAvailableCategories();
    parsedData.forEach((row, index) => {
      const rowNumber = row._rowNumber || index + 2;
      let hasErrors = false;

      try {
        const userMessage = (
          row.context ||
          row.user_message ||
          row.UserMessage ||
          row.Context ||
          row.Question ||
          row.question ||
          ''
        ).trim();

        const response = (
          row.response ||
          row.Response ||
          row.Answer ||
          row.answer ||
          ''
        ).trim();

        let expiryDate = (
          row.expiry_date ||
          row.ExpiryDate ||
          row.expiry ||
          row.Expiry ||
          row['Expiry date'] ||
          row['expiry date'] ||
          row['Expiry Date'] ||
          row.expiryDate ||
          row.expire_date ||
          row.ExpireDate ||
          row.expire ||
          row.Expire ||
          ''
        ).trim();

        const categoriesString = (
          row.category ||
          row.Categories ||
          row.Category ||
          row.categories ||
          ''
        ).trim();

        if (!userMessage) {
          errorsByCategory['Missing Context'].push(rowNumber);
          hasErrors = true;
        } else {
          const userMessageErrors = this.validateField(userMessage, 'Context');
          if (userMessageErrors.length > 0) {
            errorsByCategory['Invalid Context'].push(rowNumber);
            hasErrors = true;
          }
        }

        if (!response) {
          errorsByCategory['Missing Response'].push(rowNumber);
          hasErrors = true;
        } else {
          const responseErrors = this.validateField(response, 'Response');
          if (responseErrors.length > 0) {
            errorsByCategory['Invalid Response'].push(rowNumber);
            hasErrors = true;
          }
        }

        if (!expiryDate) {
          errorsByCategory['Missing Expiry Date'].push(rowNumber);
          hasErrors = true;
        } else {
          const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
          if (!dateRegex.test(expiryDate)) {
            errorsByCategory['Invalid Expiry Date'].push(rowNumber);
            hasErrors = true;
          } else {
            const expiryDateObj = new Date(expiryDate);
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (isNaN(expiryDateObj.getTime())) {
              errorsByCategory['Invalid Expiry Date'].push(rowNumber);
              hasErrors = true;
            } else if (expiryDateObj <= today) {
              errorsByCategory['Past Expiry Date'].push(rowNumber);
              hasErrors = true;
            }
          }
        }

        let categories = [];
        if (!categoriesString) {
          errorsByCategory['Missing Category'].push(rowNumber);
          hasErrors = true;
        } else {
          categories = categoriesString
            .split(/[;|]/)
            .map((cat) => cat.trim())
            .filter((cat) => cat);

          if (categories.length === 0) {
            errorsByCategory['Missing Category'].push(rowNumber);
            hasErrors = true;
          } else {
            const validCategoriesLowerCase = validCategories.map((cat) =>
              cat.toLowerCase(),
            );
            const invalidCategories = [];
            const validMatchedCategories = [];

            categories.forEach((cat) => {
              const lowerCat = cat.toLowerCase();
              const matchIndex = validCategoriesLowerCase.indexOf(lowerCat);

              if (matchIndex !== -1) {
                validMatchedCategories.push(validCategories[matchIndex]);
              } else {
                invalidCategories.push(cat);
              }
            });

            if (invalidCategories.length > 0) {
              errorsByCategory['Invalid Category'].push(rowNumber);
              hasErrors = true;
            } else {
              categories = validMatchedCategories;
            }
          }
        }

        if (!hasErrors) {
          configurations.push({
            id: `csv_${Date.now()}_${index}_${Math.random()
              .toString(36)
              .substr(2, 9)}`,
            UserMessage: userMessage,
            Response: response,
            ExpiryDate: expiryDate,
            Categories: categories,
            updatedBy: (
              row.updatedBy ||
              row.updated_by ||
              row.UpdatedBy ||
              ''
            ).trim(),
            updatedOn: (
              row.updatedOn ||
              row.updated_on ||
              row.UpdatedOn ||
              ''
            ).trim(),
            isFromCsv: true,
            _originalRowNumber: rowNumber,
          });
        }
      } catch (error) {
        errors.push(`Row ${rowNumber}: ${error.message}`);
      }
    });

    const formattedErrors = [];
    Object.keys(errorsByCategory).forEach((category) => {
      if (errorsByCategory[category].length > 0) {
        const rows = errorsByCategory[category].join(', ');
        let errorMessage = '';

        switch (category) {
          case 'Missing Context':
            errorMessage = `Lines ${rows} - Missing context/user message`;
            break;
          case 'Invalid Context':
            errorMessage = `Lines ${rows} - Context contains invalid characters (emojis, only numbers, only special characters, etc.)`;
            break;
          case 'Missing Response':
            errorMessage = `Lines ${rows} - Missing response`;
            break;
          case 'Invalid Response':
            errorMessage = `Lines ${rows} - Response contains invalid characters (emojis, only numbers, only special characters, etc.)`;
            break;
          case 'Missing Expiry Date':
            errorMessage = `Lines ${rows} - Missing expiry date`;
            break;
          case 'Invalid Expiry Date':
            errorMessage = `Lines ${rows} - Expiry date must be in YYYY-MM-DD format`;
            break;
          case 'Past Expiry Date':
            errorMessage = `Lines ${rows} - Expiry date must be a future date`;
            break;
          case 'Missing Category':
            errorMessage = `Lines ${rows} - Missing category`;
            break;
          case 'Invalid Category':
            errorMessage = `Lines ${rows} - Category not found in available categories`;
            break;
          default:
            errorMessage = `Lines ${rows} - ${category}`;
        }

        formattedErrors.push(errorMessage);
      }
    });

    return { configurations, errors: formattedErrors, previewColumns };
  };

  handleSaveCsvData = async () => {
    this.setState({ isSavingCsv: true, saveError: null });

    try {
      if (!this.state.csvData || this.state.csvData.length === 0) {
        throw new Error('No CSV data to save');
      }

      const validCategories = this.getAvailableCategories();

      const allFormattedData = this.state.csvData.map((config, index) => {
        let categoryArray = [];
        if (config.Categories) {
          if (Array.isArray(config.Categories)) {
            categoryArray = config.Categories.filter(
              (cat) => cat && cat.trim(),
            );
          } else if (typeof config.Categories === 'string') {
            categoryArray = config.Categories.split(/[;,|]/)
              .map((cat) => cat.trim())
              .filter((cat) => cat);
          }
        }

        const validCategoryArray = categoryArray.filter((cat) =>
          validCategories.includes(cat),
        );

        if (validCategoryArray.length === 0) {
          validCategoryArray.push('General FAQ');
        }

        return {
          UserMessage: String(config.UserMessage || '').trim(),
          Response: String(config.Response || '').trim(),
          ExpiryDate: config.ExpiryDate
            ? String(config.ExpiryDate).trim()
            : this.getTomorrowDate(),
          Categories: validCategoryArray,
        };
      });

      if (allFormattedData.length === 0) {
        throw new Error('No valid configurations to save');
      }

      const invalidConfigs = allFormattedData.filter(
        (config) => !config.UserMessage.trim() || !config.Response.trim(),
      );

      if (invalidConfigs.length > 0) {
        throw new Error(
          `${invalidConfigs.length} configurations have missing context or response`,
        );
      }

      const BATCH_SIZE = 500;
      const batches = [];

      for (let i = 0; i < allFormattedData.length; i += BATCH_SIZE) {
        batches.push(allFormattedData.slice(i, i + BATCH_SIZE));
      }

      let totalSaved = 0;
      let failedBatches = 0;
      let hasSuccessfulUploads = false;
      const failedItems = [];

      for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
        const batch = batches[batchIndex];
        try {
          const result = await this.props.bulkAddConfigurations(batch);
          totalSaved += batch.length;
          hasSuccessfulUploads = true;

          if (batchIndex < batches.length - 1) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
          }
        } catch (batchError) {
          console.error(`Batch ${batchIndex + 1} failed:`, batchError);
          failedBatches++;
          failedItems.push(
            ...batch.map((item) => item.UserMessage.substring(0, 50) + '...'),
          );

          await new Promise((resolve) => setTimeout(resolve, 2000));
          continue;
        }
      }

      this.setState({
        csvData: [],
        saveError: null,
      });

      await this.props.getConfigurations();

      if (hasSuccessfulUploads && failedBatches === 0) {
        this.setState({ isSavingCsv: false });
        this.closeCsvUploadModal();
        this.showSuccessDialog(
          `🎉 Upload Initiated Successfully!\n\n${totalSaved} AI Assist configurations have been submitted for processing.\n\n⏱️ Processing Time: Please allow 5-10 minutes for all configurations to be processed and indexed.\n\n📋 Next Steps: Check back in a few minutes to see your new configurations in the list. You can refresh the page or search for your uploaded content to verify the upload.`,
        );
      } else if (hasSuccessfulUploads && failedBatches > 0) {
        this.setState({ isSavingCsv: false });
        this.closeCsvUploadModal();
        this.showSuccessDialog(
          `✅ Partial Upload Initiated!\n\n${totalSaved} configurations have been submitted for processing successfully.\n${failedBatches} batches failed during upload.\n\n⏱️ Processing Time: Please allow 5-10 minutes for the successful configurations to be processed and available.\n\n📋 Next Steps: Check back in a few minutes and refresh the page to see your uploaded configurations.`,
        );
      } else {
        this.setState({ isSavingCsv: false });
        this.closeCsvUploadModal();
        this.showErrorDialog(
          `❌ Upload Failed\n\nAll batches failed to upload. Please check your network connection and try again.\n\nFailed batches: ${failedBatches}/${batches.length}`,
        );
      }
    } catch (error) {
      let errorMessage = 'Failed to save CSV data';
      if (error.message) {
        errorMessage = error.message;
      }

      this.setState({
        saveError: errorMessage,
        isSavingCsv: false,
      });
      this.closeCsvUploadModal();
      this.showErrorDialog(
        `❌ Upload Failed\n\n${errorMessage}\n\nPlease check your data and try again.`,
      );
    }
  };

  handleLocalSearch = (e) => {
    const searchTerm = e.target.value;
    this.setState({ localSearchTerm: searchTerm });
  };

  toggleSelectMode = () => {
    this.setState((prevState) => ({
      isSelectMode: !prevState.isSelectMode,
      selectedConfigs: [],
    }));
  };

  toggleConfigSelection = (configId) => {
    this.setState((prevState) => ({
      selectedConfigs: prevState.selectedConfigs.includes(configId)
        ? prevState.selectedConfigs.filter((id) => id !== configId)
        : [...prevState.selectedConfigs, configId],
    }));
  };

  selectAllConfigs = () => {
    const allConfigIds = this.state.filteredData
      .filter((config) => !config.isFromCsv)
      .map((config) => config.id);

    this.setState({
      selectedConfigs: allConfigIds,
    });
  };

  clearSelection = () => {
    this.setState({
      selectedConfigs: [],
    });
  };

  handleBulkDelete = () => {
    const { selectedConfigs } = this.state;

    if (selectedConfigs.length === 0) {
      this.showErrorDialog('Please select configurations to delete.');
      return;
    }

    const selectedConfigObjects = this.state.filteredData.filter((config) =>
      selectedConfigs.includes(config.id),
    );

    const csvConfigs = selectedConfigObjects.filter(
      (config) => config.isFromCsv,
    );
    if (csvConfigs.length > 0) {
      this.showErrorDialog(
        'Cannot delete CSV configurations. Please save them first.',
      );
      return;
    }

    this.showConfirmDialog(
      'Bulk Delete Configurations',
      `Are you sure you want to delete ${selectedConfigs.length} selected configuration(s)?`,
      async () => {
        try {
          this.setState({
            showConfirmModal: false,
            isBulkDeleting: true,
            isSelectMode: false,
            selectedConfigs: [],
          });

          await this.props.bulkDeleteConfigurations(selectedConfigObjects);

          this.setState({ isBulkDeleting: false });
          this.updateFilteredData();

          this.showSuccessDialog(
            `Successfully deleted ${selectedConfigs.length} configuration(s)!`,
          );
        } catch (error) {
          this.setState({
            isBulkDeleting: false,
            isSelectMode: true,
            selectedConfigs: selectedConfigs,
          });
          this.showErrorDialog(
            `Failed to delete configurations: ${error.message ||
              'Unknown error'}`,
          );
        }
      },
      'Delete All',
      'Cancel',
    );
  };

  render() {
    const { onClose, loading, error, bulkOperationInProgress } = this.props;

    const {
      filteredData,
      showCsvUploadModal,
      isProcessing,
      uploadError,
      saveError,
      csvData,
      isSavingCsv,
      validationErrors,
      uploadProgress,
      csvPreviewColumns,
      showCsvPreview,
      localSearchTerm,
      loadingCategories,
      isDeletingConfig,
      showConfirmModal,
      confirmModalConfig,
      showSuccessModal,
      successMessage,
      showErrorModal,
      errorMessage,
      selectedConfigs,
      isSelectMode,
      isBulkDeleting,
    } = this.state;

    const availableCategories = this.getAvailableCategories();

    return (
      <div className='saved-configuration-modal-container'>
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>AI Assists ({filteredData.length})</h2>
              <div className="modal-header-actions">
                {/* Bulk Delete Controls */}
                {isSelectMode && (
                  <div className="bulk-select-controls">
                    <span className="selected-count">
                      {selectedConfigs.length} selected
                    </span>
                    <button
                      className="select-all-btn"
                      onClick={this.selectAllConfigs}
                      disabled={isBulkDeleting}
                    >
                      Select All
                    </button>
                    <button
                      className="clear-selection-btn"
                      onClick={this.clearSelection}
                      disabled={isBulkDeleting}
                    >
                      Clear
                    </button>
                    <button
                      className="bulk-delete-btn"
                      onClick={this.handleBulkDelete}
                      disabled={selectedConfigs.length === 0 || isBulkDeleting}
                    >
                      <span className="material-icons">delete</span>
                      Delete Selected
                    </button>
                  </div>
                )}

                {/* Existing buttons */}
                <button
                  className="csv-btn download-btn"
                  onClick={this.downloadCsv}
                  title="Download CSV"
                  disabled={
                    loading ||
                    bulkOperationInProgress ||
                    isDeletingConfig ||
                    isBulkDeleting ||
                    filteredData.length === 0
                  }
                >
                  <span className="material-icons">download</span>
                  Download
                </button>
                <button
                  className="csv-btn upload-btn"
                  onClick={this.handleCsvUpload}
                  title="Upload CSV"
                  disabled={
                    loading ||
                    bulkOperationInProgress ||
                    isDeletingConfig ||
                    isBulkDeleting
                  }
                >
                  <span className="material-icons">upload</span>
                  Upload
                </button>
                <button className="close-btn" onClick={onClose}>
                  <span className="material-icons">close</span>
                </button>
              </div>
            </div>

            <div className="modal-body">
              {error && (
                <div className="error-message">
                  <span className="material-icons">error</span>
                  <span>Error loading configurations: {error}</span>
                </div>
              )}

              {/* {csvData.length > 0 && (
                  <div className="csv-notification">
                    <div className="csv-info">
                      <span className="material-icons">info</span>
                      <span>
                        {csvData.length} configurations loaded from CSV and ready
                        to save.
                      </span>
                    </div>
                    {validationErrors.length > 0 && (
                      <div className="validation-summary">
                        <span className="material-icons">warning</span>
                        <span>
                          {validationErrors.length} validation issues found.
                        </span>
                      </div>
                    )}
                  </div>
                )} */}

              {/* Bulk Delete Progress */}
              {isBulkDeleting && (
                <div className="bulk-delete-notification">
                  <div className="bulk-delete-progress">
                    <Loading />
                    <span>Deleting configurations...</span>
                  </div>
                </div>
              )}

              {isDeletingConfig && (
                <div className="delete-operation-notification">
                  <div className="delete-progress">
                    <Loading />
                    <span>Deleting configuration...</span>
                  </div>
                </div>
              )}

              {bulkOperationInProgress && (
                <div className="bulk-operation-notification">
                  <div className="bulk-progress">
                    <span className="material-icons spinning">sync</span>
                    <span>Bulk operation in progress... Please wait.</span>
                  </div>
                </div>
              )}

              {loadingCategories && (
                <div className="categories-loading-notification">
                  <div className="categories-progress">
                    <span>Loading...</span>
                  </div>
                </div>
              )}

              {!isDeletingConfig && !isBulkDeleting && (
                <>
                  <div className="search-container">
                    {/* Toggle Select Mode Button */}
                    <button
                      className={`select-mode-btn ${
                        isSelectMode ? 'active' : ''
                      }`}
                      onClick={this.toggleSelectMode}
                      disabled={
                        loading || bulkOperationInProgress || isBulkDeleting
                      }
                      title={
                        isSelectMode ? 'Exit Select Mode' : 'Select Multiple'
                      }
                    >
                      <span className="material-icons">
                        {isSelectMode ? 'check_box' : 'check_box_outline_blank'}
                      </span>
                      {isSelectMode ? 'Cancel' : 'Select'}
                    </button>
                    <div className="search-input-wrapper">
                      <span className="material-icons search-icon">search</span>
                      <input
                        type="text"
                        placeholder="Search AI Assists..."
                        className="search-input"
                        value={localSearchTerm}
                        onChange={this.handleLocalSearch}
                        disabled={
                          loading ||
                          bulkOperationInProgress ||
                          isDeletingConfig ||
                          isBulkDeleting
                        }
                      />
                    </div>
                  </div>

                  <div className="config-blocks">
                    {loading && filteredData.length === 0 ? (
                      <div className="config_loader">
                        <Loading />
                      </div>
                    ) : filteredData && filteredData.length > 0 ? (
                      filteredData.map((config) => (
                        <div
                          key={config.id}
                          className={`config-block ${
                            config.isFromCsv ? 'csv-config' : ''
                          } ${isSelectMode ? 'in-select-mode' : ''} ${
                            isSelectMode && selectedConfigs.includes(config.id)
                              ? 'selected'
                              : ''
                          }`}
                        >
                          {/* Selection checkbox */}
                          {isSelectMode && !config.isFromCsv && (
                            <div className="config-selection">
                              <input
                                type="checkbox"
                                className="config-checkbox"
                                checked={selectedConfigs.includes(config.id)}
                                onChange={() =>
                                  this.toggleConfigSelection(config.id)
                                }
                                disabled={isBulkDeleting}
                              />
                            </div>
                          )}

                          {this.state.editingConfigId === config.id ? (
                            <div className="config-edit-form">
                              <div className="edit-form-header">
                                <h3>
                                  <span className="material-icons">edit</span>
                                  Edit Configuration
                                </h3>
                                <div className="edit-form-actions">
                                  <button
                                    className="save-edit-btn"
                                    onClick={this.handleSaveEdit}
                                    disabled={this.state.isUpdating}
                                  >
                                    {this.state.isUpdating ? (
                                      <div className="updating-content">
                                        <span>Saving...</span>
                                      </div>
                                    ) : (
                                      <>
                                        <span className="material-icons">
                                          save
                                        </span>
                                        Save
                                      </>
                                    )}
                                  </button>
                                  <button
                                    className="cancel-edit-btn"
                                    onClick={this.handleCancelEdit}
                                    disabled={this.state.isUpdating}
                                  >
                                    <span className="material-icons">
                                      cancel
                                    </span>
                                    Cancel
                                  </button>
                                </div>
                              </div>

                              {this.state.updateError && (
                                <div className="error-message">
                                  <span className="material-icons">error</span>
                                  <span>{this.state.updateError}</span>
                                </div>
                              )}

                              <div className="edit-form-body">
                                <div className="form-field">
                                  <label className="form-label">
                                    User Message *
                                  </label>
                                  <textarea
                                    className="form-textarea"
                                    value={
                                      this.state.editFormData.UserMessage || ''
                                    }
                                    onChange={(e) =>
                                      this.handleEditFormChange(
                                        'UserMessage',
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Enter the user message or question..."
                                    rows={3}
                                    disabled={this.state.isUpdating}
                                  />
                                </div>

                                <div className="form-field">
                                  <label className="form-label">
                                    Response *
                                  </label>
                                  <textarea
                                    className="form-textarea"
                                    value={
                                      this.state.editFormData.Response || ''
                                    }
                                    onChange={(e) =>
                                      this.handleEditFormChange(
                                        'Response',
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Enter the AI assistant response..."
                                    rows={4}
                                    disabled={this.state.isUpdating}
                                  />
                                </div>

                                <div className="form-row">
                                  <div className="form-field">
                                    <label className="form-label">
                                      Expiry Date *
                                    </label>
                                    <input
                                      type="date"
                                      className="form-input"
                                      value={
                                        this.state.editFormData.ExpiryDate
                                      }
                                      min={this.getTomorrowDate()}
                                      onChange={(e) =>
                                        this.handleEditFormChange(
                                          'ExpiryDate',
                                          e.target.value,
                                        )
                                      }
                                      disabled={this.state.isUpdating}
                                      onKeyDown={(e) => e.preventDefault()}
                                      onPaste={(e) => e.preventDefault()}
                                      style={{ cursor: 'pointer' }}
                                    />
                                  </div>

                                  <div className="form-field">
                                    <label className="form-label">
                                      Categories ({availableCategories.length}{' '}
                                      available)
                                      {loadingCategories && (
                                        <span className="material-icons spinning category-loading-icon">
                                          sync
                                        </span>
                                      )}
                                    </label>
                                    <div className="categories-input">
                                      <Select
                                        isMulti={false}
                                        isClearable={true}
                                        placeholder={
                                          loadingCategories
                                            ? 'Loading categories...'
                                            : 'Add category...'
                                        }
                                        options={availableCategories.map(
                                          (cat) => ({
                                            value: cat,
                                            label: cat,
                                          }),
                                        )}
                                        onChange={(selectedOption) => {
                                          if (
                                            selectedOption &&
                                            selectedOption.value
                                          ) {
                                            const currentCategories =
                                              this.state.editFormData
                                                .Categories || [];
                                            if (
                                              !currentCategories.includes(
                                                selectedOption.value,
                                              )
                                            ) {
                                              const newCategories = [
                                                ...currentCategories,
                                                selectedOption.value,
                                              ];
                                              this.handleCategoryChange(
                                                newCategories,
                                              );
                                            }
                                          }
                                        }}
                                        className="form-select"
                                        components={{
                                          DropdownIndicator,
                                          IndicatorSeparator: () => null,
                                        }}
                                        styles={multiSelectdropdownCustomStyle}
                                        disabled={
                                          this.state.isUpdating ||
                                          loadingCategories
                                        }
                                        value={null}
                                        isLoading={loadingCategories}
                                      />
                                      <div className="selected-categories">
                                        {this.state.editFormData.Categories &&
                                          this.state.editFormData.Categories.map(
                                            (cat, idx) => (
                                              <span
                                                key={idx}
                                                className="category-tag editable"
                                              >
                                                {cat}
                                                <button
                                                  type="button"
                                                  className="remove-category"
                                                  onClick={() => {
                                                    const newCategories = this.state.editFormData.Categories.filter(
                                                      (_, i) => i !== idx,
                                                    );
                                                    this.handleCategoryChange(
                                                      newCategories,
                                                    );
                                                  }}
                                                  disabled={
                                                    this.state.isUpdating
                                                  }
                                                >
                                                  <span className="material-icons">
                                                    close
                                                  </span>
                                                </button>
                                              </span>
                                            ),
                                          )}
                                        {(!this.state.editFormData.Categories ||
                                          this.state.editFormData.Categories
                                            .length === 0) && (
                                          <span className="no-categories-selected">
                                            No categories selected
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    {availableCategories.length === 0 &&
                                      !loadingCategories && (
                                        <div className="categories-fallback-info">
                                          <span className="material-icons">
                                            info
                                          </span>
                                          <span>
                                            Using default categories. Categories
                                            service may be unavailable.
                                          </span>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="config-block-header">
                                <h3>
                                  {config.UserMessage || 'No message'}
                                  {config.isFromCsv && (
                                    <span className="csv-badge">From CSV</span>
                                  )}
                                </h3>
                                <div className="config-actions">
                                  <button
                                    className="edit-btn"
                                    onClick={() => this.handleEdit(config)}
                                    title={
                                      config.isFromCsv
                                        ? 'Save CSV data first to edit'
                                        : 'Edit'
                                    }
                                    disabled={
                                      config.isFromCsv ||
                                      bulkOperationInProgress ||
                                      isDeletingConfig ||
                                      isBulkDeleting ||
                                      isSelectMode
                                    }
                                  >
                                    <span className="material-icons">edit</span>
                                  </button>
                                  <button
                                    className="delete-btn"
                                    onClick={() => this.handleDelete(config.id)}
                                    title={
                                      config.isFromCsv
                                        ? 'Remove from upload list'
                                        : 'Delete'
                                    }
                                    disabled={
                                      bulkOperationInProgress ||
                                      isDeletingConfig ||
                                      isBulkDeleting ||
                                      isSelectMode
                                    }
                                  >
                                    <span className="material-icons">
                                      {config.isFromCsv ? 'remove' : 'delete'}
                                    </span>
                                  </button>
                                </div>
                              </div>

                              <div className="config-block-body">
                                <div className="config-block-content">
                                  <div className="config-response-section">
                                    <h4 className="section-title">Response:</h4>
                                    <p className="config-response">
                                      {config.Response || 'No response'}
                                    </p>
                                  </div>
                                </div>

                                <div className="config-block-meta">
                                  <div className="config-categories">
                                    {config.Categories &&
                                    config.Categories.length > 0 ? (
                                      <div className="categories-tags">
                                        {config.Categories.map((cat, idx) => (
                                          <span
                                            key={idx}
                                            className="category-tag"
                                          >
                                            {cat}
                                          </span>
                                        ))}
                                      </div>
                                    ) : (
                                      <span className="no-categories">
                                        No categories
                                      </span>
                                    )}
                                  </div>
                                  <div className="config-details">
                                    {config.ExpiryDate &&
                                      config.ExpiryDate !== 'undefined' &&
                                      config.ExpiryDate !== null && (
                                        <div className="config-expiry">
                                          <span className="expiry-label">
                                            Expires:
                                          </span>
                                          <span className="expiry-value">
                                            {new Date(
                                              config.ExpiryDate,
                                            ).toLocaleDateString()}
                                          </span>
                                        </div>
                                      )}
                                    {config.updatedBy &&
                                      config.updatedBy !== null && (
                                        <div className="config-expiry">
                                          <span className="expiry-label">
                                            Updated By:
                                          </span>
                                          <span className="expiry-value">
                                            {config.updatedBy}
                                          </span>
                                        </div>
                                      )}
                                    {config.updatedOn &&
                                      config.updatedOn !== null && (
                                        <div className="config-expiry">
                                          <span className="expiry-label">
                                            Updated On:
                                          </span>
                                          <span className="expiry-value">
                                            {new Date(
                                              config.updatedOn,
                                            ).toLocaleDateString()}
                                          </span>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="no-configs">
                        <span className="material-icons">search_off</span>
                        <p>
                          {localSearchTerm
                            ? `No AI Assists found matching "${localSearchTerm}"`
                            : 'No AI Assists found'}
                        </p>
                        {localSearchTerm && (
                          <button
                            className="clear-search-btn-alt"
                            onClick={() => {
                              this.setState({ localSearchTerm: '' });
                              this.updateFilteredData();
                            }}
                          >
                            Clear Search
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </>
              )}
              {validationErrors.length > 0 && (
                <div className="validation-errors">
                  <h4>
                    <span className="material-icons">warning</span>
                    Validation Issues:
                  </h4>
                  <ul style={{ zIndex: 1060, position: 'relative' }}>
                    {validationErrors.map((error, index) => (
                      <li key={index} className="validation-error">
                        <span className="material-icons">error_outline</span>
                        {error}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* CSV Upload Modal */}
        {showCsvUploadModal && (
          <div
            className="modal-overlay"
            onClick={!isSavingCsv ? this.closeCsvUploadModal : undefined}
            style={{ zIndex: 1050 }}
          >
            <div
              className="modal-content csv-upload-modal"
              onClick={(e) => e.stopPropagation()}
              style={{ zIndex: 1051 }}
            >
              <div className="modal-header">
                <h2>Upload CSV File</h2>
                <button
                  className="close-btn"
                  onClick={this.closeCsvUploadModal}
                  disabled={isSavingCsv}
                >
                  <span className="material-icons">close</span>
                </button>
              </div>

              <div className="modal-body">
                {/* Show full loading overlay when saving CSV */}
                {isSavingCsv && (
                  <div className="csv-saving-overlay">
                    <div className="csv-saving-content">
                      <Loading />
                      <h3>Uploading AI Assist Configurations...</h3>
                      <p>
                        Please wait while we process and upload your CSV data.
                      </p>
                      <p>
                        This may take a few moments depending on the file size.
                      </p>
                    </div>
                  </div>
                )}

                {/* Normal upload content - hidden when saving */}
                <div
                  className={`csv-upload-content ${
                    isSavingCsv ? 'hidden' : ''
                  }`}
                >
                  {!isProcessing && csvData.length === 0 && (
                    <div className="file-upload-section">
                      <input
                        ref={this.fileInputRef}
                        type="file"
                        accept=".csv"
                        onChange={this.handleFileSelect}
                        className="file-input"
                        id="csv-file-input"
                      />
                      <label
                        htmlFor="csv-file-input"
                        className="file-upload-label"
                      >
                        <span className="material-icons">cloud_upload</span>
                        Choose CSV File
                      </label>
                    </div>
                  )}

                  {isProcessing && (
                    <div className="csv_loader">
                      <Loading />
                      <div className="processing-status">
                        <p>Processing CSV file... {uploadProgress}%</p>
                      </div>
                    </div>
                  )}

                  {uploadError && (
                    <div className="error-message">
                      <span className="material-icons">error</span>
                      <span>{uploadError}</span>
                    </div>
                  )}

                  {saveError && (
                    <div className="error-message">
                      <span className="material-icons">error</span>
                      <span>{saveError}</span>
                    </div>
                  )}

                  {(csvData.length > 0 || validationErrors.length > 0) && (
                    <div className="csv-data-summary">
                      <div className="summary-info">
                        <span className="material-icons">check_circle</span>
                        <p>
                          {csvData.length} configurations are ready to upload.
                        </p>
                      </div>

                      {validationErrors.length > 0 && (
                        <div className="validation-warning">
                          <p>
                            <span className="material-icons">warning</span>
                            {validationErrors.length} validation issues found.
                            Please fix these before uploading.
                          </p>

                          {/* Detailed validation errors list */}
                          <div
                            className="detailed-validation-errors"
                            style={{
                              marginTop: '15px',
                              borderRadius: '4px',
                              maxHeight: '200px',
                              overflowY: 'auto',
                            }}
                          >
                            <ul
                              style={{
                                listStyle: 'none',
                                padding: '0',
                                margin: '0',
                              }}
                            >
                              {validationErrors.map((error, index) => (
                                <li
                                  key={index}
                                  style={{
                                    marginBottom: '8px',
                                    padding: '8px',
                                    backgroundColor: '#fff',
                                    borderRadius: '3px',
                                    borderLeft: '4px solid #ffc107',
                                    fontSize: '13px',
                                    color: '#856404',
                                  }}
                                >
                                  <span
                                    className="material-icons"
                                    style={{
                                      fontSize: '16px',
                                      marginRight: '8px',
                                      verticalAlign: 'middle',
                                      color: '#dc3545',
                                    }}
                                  >
                                    error_outline
                                  </span>
                                  <span style={{ verticalAlign: 'middle' }}>
                                    {error}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {csvData.length > 0 && !isSavingCsv && (
                  <div className="csv-save-section">
                    <button
                      className="save-csv-btn btn btn--primary btn--lg"
                      onClick={this.handleSaveCsvData}
                      disabled={
                        isSavingCsv ||
                        bulkOperationInProgress ||
                        validationErrors.length > 0
                      }
                    >
                      <div>Save CSV Data ({csvData.length} items)</div>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Confirmation Modal */}
        {showConfirmModal && (
          <div className="modal-overlay" onClick={confirmModalConfig.onCancel}>
            <div
              className="modal-content confirmation-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <h2>{confirmModalConfig.title}</h2>
                <button
                  className="close-btn"
                  onClick={confirmModalConfig.onCancel}
                >
                  <span className="material-icons">close</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="confirmation-content">
                  <p>{confirmModalConfig.message}</p>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="cancel-btn"
                  onClick={confirmModalConfig.onCancel}
                >
                  {confirmModalConfig.cancelText}
                </button>
                <button
                  className="confirm-btn"
                  onClick={confirmModalConfig.onConfirm}
                >
                  {confirmModalConfig.confirmText}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Success Modal */}
        {showSuccessModal && (
          <div className="modal-overlay" onClick={this.closeAllModals}>
            <div
              className="modal-content success-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <h2>Success</h2>
                <button className="close-btn" onClick={this.closeAllModals}>
                  <span className="material-icons">close</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="success-content">
                  <span className="material-icons success-icon">
                    check_circle
                  </span>
                  <p>{successMessage}</p>
                </div>
              </div>
              <div className="modal-footer">
                <button className="ok-btn" onClick={this.closeAllModals}>
                  OK
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Error Modal */}
        {showErrorModal && (
          <div className="modal-overlay" onClick={this.closeAllModals}>
            <div
              className="modal-content error-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <h2>Error</h2>
                <button className="close-btn" onClick={this.closeAllModals}>
                  <span className="material-icons">close</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="error-content">
                  <span className="material-icons error-icon">error</span>
                  <p>{errorMessage}</p>
                </div>
              </div>
              <div className="modal-footer">
                <button className="ok-btn" onClick={this.closeAllModals}>
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

SavedConfigurationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  getConfigurations: PropTypes.func.isRequired,
  deleteConfiguration: PropTypes.func.isRequired,
  bulkDeleteConfigurations: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  bulkAddConfigurations: PropTypes.func.isRequired,
  configurations: PropTypes.array,
  searchTerm: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.string,
  bulkOperationInProgress: PropTypes.bool,
  availableCategories: PropTypes.array,
};

SavedConfigurationModal.defaultProps = {
  configurations: [],
  searchTerm: '',
  loading: false,
  error: null,
  bulkOperationInProgress: false,
  availableCategories: [],
  onEdit: null,
};

const mapStateToProps = (state) => {
  let aiAssistState = null;
  let categories = [];
  const possiblePaths = [
    'aiAssistConfig',
    'aiAssist',
    'aiAssists',
    'configurations',
    'config',
    'assistant',
    'ai',
  ];

  for (const path of possiblePaths) {
    if (state[path]) {
      aiAssistState = state[path];
      categories =
        aiAssistState.categories ||
        aiAssistState.availableCategories ||
        aiAssistState.categoryList ||
        aiAssistState.categoriesData ||
        [];

      if (aiAssistState.configurations) {
        break;
      }
    }
  }

  if (
    !aiAssistState ||
    (!aiAssistState.configurations && categories.length === 0)
  ) {
    const searchState = (obj, path = '') => {
      if (obj && typeof obj === 'object') {
        if (obj.configurations && Array.isArray(obj.configurations)) {
          aiAssistState = obj;
        }
        const categoryKeys = [
          'categories',
          'availableCategories',
          'categoryList',
          'categoriesData',
        ];
        for (const key of categoryKeys) {
          if (obj[key] && Array.isArray(obj[key]) && obj[key].length > 0) {
            categories = obj[key];
          }
        }
        for (const key in obj) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            searchState(obj[key], path ? `${path}.${key}` : key);
          }
        }
      }
    };

    searchState(state);
  }

  if (!aiAssistState) {
    aiAssistState = {
      configurations: [],
      loading: false,
      error: null,
      bulkOperationInProgress: false,
    };
  }

  return {
    configurations: aiAssistState.configurations || [],
    loading: aiAssistState.loading || false,
    error: aiAssistState.error || null,
    bulkOperationInProgress: aiAssistState.bulkOperationInProgress || false,
    availableCategories: categories,
  };
};

const mapDispatchToProps = {
  getConfigurations,
  getCategories,
  bulkAddConfigurations,
  deleteConfiguration,
  bulkDeleteConfigurations,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SavedConfigurationModal);
